import styled from "styled-components/macro";
import { Flex } from "@rebass/grid";

import { Theme } from "app.css";

const Container = styled(Flex)`
  z-index: 999;
  > div {
    margin-top: 200px;
  }
  #auth0-container {
    margin-top: -30px;
    min-height: 150px;
    min-width: 300px;
    .auth0-lock.auth0-lock {
      .auth0-lock-cred-pane {
        background: none;
      }
      .auth0-lock-header {
        display: none;
      }
      .auth0-lock-cred-pane {
        border-radius: 0;
      }
      .auth0-lock-content-wrapper {
        background-color: ${Theme.white};
        border-radius: 0 0 5px 5px;
        padding-bottom: 10px;
        overflow: hidden;
      }
      .auth0-lock-submit {
        margin-top: -10px;
      }
      .auth0-lock-confirmation {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        .auth0-lock-confirmation-content {
          position: relative;
          width: auto;
          top: 0;
          left: 0;
          transform: none;
          p {
            margin-top: 8px;
            margin-bottom: 0;
          }
        }
      }
    }
  }
  #error {
    padding-top: 1rem;
    z-index: 1000;
  }
`;

const Logo = styled(Flex)`
  position: relative;
  height: 70px;
  z-index: 4;
  img {
    display: inline-flex;
    height: 32px;
    min-height: 32px;
    max-height: 32px;
  }
`;

const Main = styled(Flex)`
  > header {
    border-radius: 5px;
    padding-bottom: 10px;
    background-color: ${Theme.white};
    z-index: 999;
  }
`;

const Dimmer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  background-color: ${Theme.secondary};
  z-index: 998;
`;

export default {
  Container,
  Logo,
  Main,
  Dimmer
};
